import { Button } from "@mui/material";

const MAIL_ADDRESS = "info@solairegroup.co.uk";

const mailSubjects = {
  training: "Training Inquiry",
  bidWriting: "Bid Writing Support Request",
  consultancy: "Consultancy Service Request",
};

const mailBodies = {
  training:
    "Hello,\n\nI am interested in your training services and would like to know more about the available programs.\n\nBest regards,",
  bidWriting:
    "Hello,\n\nI am seeking assistance with bid writing and would like to discuss potential collaboration.\n\nBest regards,",
  consultancy:
    "Hello,\n\nI would like to inquire about your consultancy services for my organization.\n\nBest regards,",
};

export default function MailButton({
  mailType = "consultancy",
  children,
  ...props
}) {
  const subject = encodeURIComponent(
    mailSubjects[mailType] || "Consultancy Inquiry"
  );
  const body = encodeURIComponent(
    mailBodies[mailType] ||
      "Hello,\n\nI would like to learn more about your services.\n\nBest regards,"
  );
  const mailtoLink = `mailto:${MAIL_ADDRESS}?subject=${subject}&body=${body}`;

  return (
    <Button
      href={mailtoLink}
      component="a"
      target="_blank"
      rel="noopener noreferrer"
      variant="contained"
      sx={{
        backgroundColor: "#383184",
        "&:hover": { backgroundColor: "#F08A16" },
        borderRadius: "8px",
        px: 3,
        py: 1.5,
        textTransform: "none",
      }}
      {...props}
    >
      {children || "Send Email"}
    </Button>
  );
}
